var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1647 19.6139V4.94727H15.1647V0.947266H3.16471V19.6139H0.498047V20.9473H9.83138V16.9473H12.498V20.9473H21.8314V19.6139H19.1647ZM8.49805 14.2806H5.83138V11.6139H8.49805V14.2806ZM8.49805 10.2806H5.83138V7.61393H8.49805V10.2806ZM8.49805 6.2806H5.83138V3.61393H8.49805V6.2806ZM12.498 14.2806H9.83138V11.6139H12.498V14.2806ZM12.498 10.2806H9.83138V7.61393H12.498V10.2806ZM12.498 6.2806H9.83138V3.61393H12.498V6.2806ZM17.8314 14.2806H15.1647V11.6139H17.8314V14.2806ZM17.8314 10.2806H15.1647V7.61393H17.8314V10.2806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.f5cb16423473569b79d51df54ff1c6f1.svg";
export { ForwardRef as ReactComponent };